const scrollToTop = () => {
  const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

  if(winScroll > 0) {
    window.scrollTo(0, 0);
  }
};

export default scrollToTop;